import { loadable } from 'utils';

export const Contact = loadable(() => import('./Contact'), {});
export const Request = loadable(() => import('./Request'), {});
export const Import = {
  Basic: loadable(() => import('./Import/Basic'), {}),
  Contacts: loadable(() => import('./Import/Contacts'), {}),
  Products: loadable(() => import('./Import/Products'), {}),
};
export const Product = loadable(() => import('./Product'), {});
